import { LngLatGeolocation, Geolocation } from "../types";

export class BoundingBox {
  private _northEast: LngLatGeolocation;
  private _southWest: LngLatGeolocation;

  constructor(northEast: LngLatGeolocation, southWest: LngLatGeolocation) {
    this._northEast = northEast;
    this._southWest = southWest;
  }

  contains(location: Geolocation) {
    let normalizedLocation: LngLatGeolocation;

    if (Array.isArray(location)) {
      // Array format is assumed to be [longitude, latitude]
      normalizedLocation = { lng: location[0], lat: location[1] };
    } else if ("lon" in location) {
      // If the object has 'lon' instead of 'lng'
      normalizedLocation = { lng: location.lon, lat: location.lat };
    } else {
      // The location is already in LngLatGeolocation format
      normalizedLocation = location;
    }

    // Check if the location is within the bounding box

    return (
      normalizedLocation.lat <= this._northEast.lat &&
      normalizedLocation.lat >= this._southWest.lat &&
      normalizedLocation.lng <= this._northEast.lng &&
      normalizedLocation.lng >= this._southWest.lng
    );
  }

  getNorthEast() {
    return this._northEast;
  }

  getNorthWest() {
    return { lat: this._northEast.lat, lng: this._southWest.lng };
  }

  getSouthWest() {
    return this._southWest;
  }

  getSouthEast() {
    return { lat: this._southWest.lat, lng: this._northEast.lng };
  }
}
